import { db } from './Firebase'

function sortValue(a,b,prop) {
  if (a[prop] != undefined && b[prop] != undefined) {
    return a[prop] > b[prop] ? 1 : a[prop] < b[prop] ? -1 : 0
  } else if (a[prop] != undefined) {
    return -1
  } else if (b[prop] != undefined) {
    return 1
  } else {
    return 0
  }
}

function sort(fields:FormField[], props:string[]) {
  props.reverse().forEach(prop => {
    fields.sort((a,b) => {
      return sortValue(a,b,prop)
    })
  })
  return fields
}

function defaultValues(schema:object) {
  const values = {}


  Object.entries(schema).forEach(([key, props]) => {
    if (props.display == "field") Object.assign(values, {[key]: props.defaultValue || null})
  })

  return values
}

function toArray(schema):any[] {
  const fields = [] as any[]
  Object.entries(schema).forEach(([key, props]) => {
    fields.push({key, ...props})
  })
  return fields
}

const get = async (resource) => {
  try {
    const schema = await db.collection("schemas").doc(resource).get()
    if (schema.exists) {
      return toArray(schema.data())
    } else {
      throw {
        code: "schema/not-found",
        message: "Schema not found.",
        status: 404
      }
    }
  } catch (err) {
    const error = {
      code: err.code || "error/unknown",
      message: err.message || "An unknown error occurred.",
      status: err.status || 500
    }
    throw error
  }
}

export default {
  install(Vue) {
    Vue.prototype.$schema = { defaultValues, get, sort, sortValue, toArray }
  }
}
